const pay = {
	state:{
		payStyle:0,
		orderNo:'',
		orderId:'',
		payHtml:''
	},
	getters:{
		payStyle:state => state.payStyle,
		orderNo:state => state.orderNo,
		orderId:state => state.orderId,
		payHtml:state => state.payHtml,
	},
	mutations:{
		setPayStyle(state,payload){
			state.payStyle = payload
		},
		setOrderNo(state,payload){
			state.orderNo = payload
		},
		setOrderId(state,payload){
			state.orderId = payload
		},
		setPayHtml(state,payload){
			state.payHtml = payload
		},
	}
}

export default pay


// WEBPACK FOOTER //
// ./src/utils/store/module/pay.js